import { Suspense } from 'react';
import { HashRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import  MainLayout  from '../layouts/OneLandingPage.js';
// import { MainLayout } from '../layouts/MainLayout.js';
import { Loader } from '../../core/shared/Loader.jsx';
import { resolveModules } from '../../modules/moduleRegistry.js';
import { getSystemConfig } from '../../core/systems/systemRegistry.js';
import { Button } from 'semantic-ui-react';
import CardCostomosted from 'modules/CardCostomosted.js';

/**
 * AppRouter.jsx
 *
 * Builds the entire route tree from the enabled module list. There is
 * no static list of routes anywhere in the source — remove or add a
 * module id (or a submodule) in moduleRegistry.js and the available
 * routes change automatically. This file itself never needs to change
 * to add a new module or a new sub-page.
 *
 * Submodules are rendered as flat sibling routes (path =
 * `${parentPath}/${submodulePath}`), not nested <Route> children —
 * this avoids requiring every parent module component to render an
 * <Outlet />. A submodule is reachable only if its parent module id is
 * already present in `items`, i.e. already enabled for this user.
 */
export function AppRouter({ systemId, enabledModules }) {
  const items = resolveModules(enabledModules);
  const config = getSystemConfig(systemId);
  const landingPath = items.find((m) => m.id === config.defaultModule)?.path ?? items[0]?.path;

  function withCardWrapper(LazyComponent, cardData) {
    return function Wrapped(props) {
      return (
        <CardCostomosted cardData={cardData}>
          <Suspense fallback={null}>
            <LazyComponent {...props} />
          </Suspense>
        </CardCostomosted>
      );
    };
  }

  function resolveComponent(item) {
    return item.withoutCardWrapper
      ? item.component
      : withCardWrapper(item.component, item.cardData) ;
  }

  return (
    <HashRouter>
      <Routes>
        <Route element={<Outlet />}>
          {landingPath ? (
            <Route index element={<Navigate to={landingPath} replace />} />
          ) : null}

          {items.map((item) => {
            const ModuleComponent = resolveComponent(item);
            return (
              <Route
                key={item.id}
                path={item.path}
                element={
                  <Suspense fallback={<Loader label={`Chargemment ...`} />}>
                    <ModuleComponent />
                  </Suspense>
                }
              />
            );
          })}

          {items.flatMap((item) =>
            (item.submodules ?? []).map((sub) => {
              const SubComponent = resolveComponent(sub);
              return (
                <Route
                  key={`${item.id}-${sub.id}`}
                  path={`${item.path}/${sub.path}`}
                  element={
                    <Suspense fallback={<Loader label={`Loading ${sub.label}...`} />}>
                      <SubComponent />
                    </Suspense>
                  }
                />
              );
            })
          )}

          <Route
            path="*"
            element={
              <div style={{ padding: 24 }}>
                <div className="cpntainer text-danger pt-5 text-center">
                  <br /> <br /> <br /> <br />
                  <img src='https://cdn.abyedh.com/Images/system/404.svg' width='200px' className='img-responsive' />
                  <h1 style={{color: 'red'}}>Page Introuvable 404</h1>
                  <Button className='rounded-pill' onClick={() => window.location.href = '/'}>Page d'accueil</Button>
                </div>
              </div>
            }
          />
        </Route>
      </Routes>
    </HashRouter>
  );
}
